// extracted by mini-css-extract-plugin
export default {"loading":"loading--aGTjb","text":"text--RWdQ5"};